import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  Card,
  Typography,
  Avatar,
  Drawer,
  useMediaQuery,
  Tooltip,
  IconButton,
  Chip,
  InputAdornment,
  Dialog,
  FormControlLabel,
  Checkbox,
  TablePagination,
} from "@mui/material";
import {
  useGetAllWorkshopQuery,
  useGetUserQuery,
  useGetTaskQuery,
  useCreateTaskMutation,
  useGetCustomerQuery,
  useGetTeamQuery,
  useDeleteWorkshopRegistrationsMutation,
} from "../../../Api/attoDeskApi";
import { IWorkShop, IUserInfo } from "../../../Api/Interface/api.interface";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import dayjs, { Dayjs } from "dayjs";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { styled, useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import { useNotifier } from "../../../Core/Notifier";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import TableViewIcon from "@mui/icons-material/TableView";
import * as XLSX from "xlsx";
import {
  DataGrid,
  GridColDef,
  GridPagination,
  GridPaginationModel,
  GridRenderCellParams,
  GridRowSelectionModel,
  GridToolbar,
} from "@mui/x-data-grid";
import { CiSearch } from "react-icons/ci";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import NewPopUpCustomer from "../Edit/index";
import NewPopUpCustomerSt from "../Edit/status";
import NewPopUpCustomerRe from "../Edit/reschedule";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import ListAltIcon from "@mui/icons-material/ListAlt";
import MessageIcon from "@mui/icons-material/Message";
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import SendIcon from "@mui/icons-material/Send";
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';

const capitalizeFirstLetter = (name: string | null | undefined) => {
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

const allColumns = [
  "Register Date",
  "Name",
  "E-mail",
  "Phone Number",
  "No of Participants",
  "Message",
  "Status",
];

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 100,
  });

  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const { data: userData } = useGetUserQuery();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [selectedMeetingData, setSelectedMeetingData] =
    useState<IWorkShop | null>(null);
  const { showErrorMessage, showMessage } = useNotifier();
  const [selectedCustomerId, setSelectedCustomerId] = useState<string | "">("");
  const prevClientIdRef = useRef<string | "">("");

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const startDateAsDate = startDate?.toDate() || null;
  const endDateAsDate = endDate?.toDate() || null;

  const [selectedStaffId, setSelectedStaffId] = useState<string | "">("");
  const [selectedClientId, setSelectedClientId] = useState<string | "">("");
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | "">("");

  const [selectedRowIds, setSelectedRowIds] = useState<GridRowSelectionModel>(
    []
  );

  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");

  const [selectedFinalStatuses, setSelectedFinalStatuses] = useState<string[]>(
    []
  );

  const [selectedCoursing, setSelectedCoursing] = useState<IWorkShop | null>(
    null
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCoursingSt, setSelectedCoursingSt] =
    useState<IWorkShop | null>(null);
  const [openDialogSt, setOpenDialogSt] = useState(false);
  const [selectedCoursingRe, setSelectedCoursingRe] =
    useState<IWorkShop | null>(null);
  const [openDialogRe, setOpenDialogRe] = useState(false);

  const [open, setOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [isPaperVisible, setIsPaperVisible] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IWorkShop | null>(
    null
  );
  const [message, setMessage] = useState("");

  const [newDepartment, { isLoading: meetingSaveIsLoading }] =
    useCreateTaskMutation();

  const userId = React.useMemo(() => {
    if (userData?.data) {
      const userInfo = userData.data as IUserInfo;
      return userInfo.staffId;
    }
    return "";
  }, [userData]);

  const { data, isLoading, isError, refetch } = useGetAllWorkshopQuery({
    searchText: currentSearchQuery,
    staffId: selectedStaffId,
    clientId: selectedClientId,
    id: "",
    fromDate: startDateAsDate as Date,
    toDate: endDateAsDate as Date,
    categoryId: selectedCategoryId,
    multi_final_status_filter: selectedFinalStatuses,
  });

  const {
    data: meetingData,
    isLoading: meetingLoading,
    error: meetingIsError,
  } = useGetTaskQuery(
    {
      searchText: "",
      staffId: userId || "",
      clientId: "",
      id: selectedId || "",
      meeting_Date: "",
    },
    {
      skip: !selectedId,
    }
  );

  const fristIndexMeeting = useMemo(() => {
    if (
      meetingData &&
      Array.isArray(meetingData.data) &&
      meetingData.data.length > 0
    ) {
      return meetingData.data[0] as IWorkShop;
    }
    return null;
  }, [meetingData]);

  const finalStatusOptions = [
    { label: "Pending", value: "Pending" },
    { label: "Confirm", value: "Confirm" },
    { label: "Completed", value: "Completed" },
    { label: "Cancel", value: "Cancel" },
  ];

  useEffect(() => {
    if (debouncedSearchQuery.length >= 2 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  useEffect(() => {
    if (fristIndexMeeting) {
      setSelectedMeetingData(fristIndexMeeting);
    }
  }, [fristIndexMeeting, meetingLoading]);

  const handleStartDateChange = (newValue: Dayjs | null) => {
    setStartDate(newValue);
  };

  const handleEndDateChange = (newValue: Dayjs | null) => {
    setEndDate(newValue);
  };

  const coursings: IWorkShop[] = Array.isArray(data?.data)
    ? (data?.data as IWorkShop[])
    : [];

  const handleAddProductClick = () => {
    navigate(`/workshop/create`);
  };

  const handleEmailHistory = () => {
    navigate(`/workshop/newsletter/e-mail/history`);
  };

  const handleFeedbackHistory = () => {
    navigate(`/workshop/feedback/list`);
  };

  const resetFields = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedStaffId("");
    setSelectedClientId("");
    setSelectedCategoryId("");
    setCurrentSearchQuery("");
    setSearchQuery("");
    setSelectedFinalStatuses([]);
  };

  const handleOpenDialog = (coursing: IWorkShop) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDialogSt = (coursing: IWorkShop) => {
    setSelectedCoursingSt(coursing);
    setOpenDialogSt(true);
  };

  const handleCloseDialogSt = () => {
    setSelectedCoursingSt(null);
    setOpenDialogSt(false);
  };

  const handleOpenDialogRe = (coursing: IWorkShop) => {
    setSelectedCoursingRe(coursing);
    setOpenDialogRe(true);
  };

  const handleCloseDialogRe = () => {
    setSelectedCoursingRe(null);
    setOpenDialogRe(false);
  };

  const handleOpen = () => {
    setSelectedColumns(allColumns);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedColumns(allColumns);
    } else {
      setSelectedColumns([]);
    }
  };

  const handleCheckboxChange = (column: string) => {
    setSelectedColumns((prev) =>
      prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column]
    );
  };

  const handleRowSelection = (selectionModel: GridRowSelectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  const handleNavigate = () => {
    if (selectedRowIds.length > 0) {
      // Pass as query params
      navigate(`/workshop/newsletter/e-mail?ids=${selectedRowIds.join(",")}`);

      // Or pass as state (cleaner)
      // navigate("/emails", { state: { ids: selectedRowIds } });
    }
  };

  const handleToggle = () => {
    setIsPaperVisible(!isPaperVisible);
  };

  const handleExport = () => {
    handleExportExcel(selectedColumns);
    handleClose();
  };
  const [deleteCategory] = useDeleteWorkshopRegistrationsMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteCategory(false);
      } else {
        setMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the Client");
    }
  };

  const handleOpenDeletePopup = (coursing: IWorkShop) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  if (isLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const handleExportExcel = (selectedCols: string[]) => {
    const coursings: IWorkShop[] = Array.isArray(data?.data)
      ? (data?.data as IWorkShop[])
      : [];

    const selectedRows = coursings.filter((row) =>
      selectedRowIds.includes(row.id)
    );

    if (selectedRows.length === 0) {
      alert("Please select at least one row to export!");
      return;
    }
    const fullExcelData = selectedRows.map((row) => ({
      "Register Date":  dayjs(row.created_at).format("MMM D, YYYY") || "",
      "Name": row.name || "",
      "E-mail": (row.email || "").toLowerCase() || "",
      "Phone Number": formatPhoneNumberForDisplay(row.phone_number) || "",
      "No of Participants": row.no_of_participants || "",
      "Message": row.message || "",
      "Status": row.status || "",

    }));

    const filteredExcelData = fullExcelData.map((row) => {
      const filteredRow: any = {};
      selectedCols.forEach((col) => {
        filteredRow[col] = row[col as keyof typeof row];
      });
      return filteredRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(filteredExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "workshop");
    const today = dayjs();
    const formattedDate = today.format("MMM, DD YYYY (dddd)");
    const filename = `workshop_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const columns: GridColDef[] = [
    {
      field: "createDateOnly",
      headerName: "Register Date",
      minWidth: 100,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        return params.value ? dayjs(params.value).format("MMM D, YYYY") : "";
      },
    },
    {
      field: "name",
      headerName: "Name",
      minWidth: 220,
      flex: 1,
      // renderCell: (params: GridRenderCellParams) => <span>{params.value}</span>,
      renderCell: (params: GridRenderCellParams) => {
        const customerRefId = params.row.name;
        const customermessage = params.row.message;

        // If customerRefId is null or empty, just return plain text
        if (!customerRefId) {
          return <span></span>;
        }

        return (
          <>
            <Link
              to={`/workshop/history/${params.row.id}`}
              className={classes.iconLinkPropNormal}
            >
              <span
                style={{
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                }}
                // onClick={() => navigate(`/profile/customer/${params.row.id}`)}
              >
                {customerRefId}
              </span>
            </Link>
            {customermessage && (
              <Tooltip title={customermessage} arrow placement="top">
                <IconButton size="small">
                  <MessageIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      field: "no_of_participants",
      headerName: "No of Participants",
      minWidth: 50,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => <span>{params.value}</span>,
    },
    {
      field: "email",
      headerName: "email",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "phone_number",
      headerName: "Phone Number",
      minWidth: 220,
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        formatPhoneNumberForDisplay(params.row.phone_number),
    },

    {
      field: "finalStatus",
      headerName: "Status",
      minWidth: 180,
      flex: 1,
      renderCell: (params: GridRenderCellParams) => {
        const value = (params.value as string)?.toLowerCase();

        let bgColor: string = "#9e9e9e";
        let label: string = "Pending";

        switch (value) {
          case "completed":
            bgColor = "#2e7d32";
            label = "Completed";
            break;
          case "confirm":
            bgColor = "#0288d1";
            label = "Confirm";
            break;
          case "pending":
            bgColor = "#f9a825";
            label = "Pending";
            break;
          case "cancel":
            bgColor = "#d32f2f";
            label = "Cancel";
            break;
          default:
            bgColor = "#f9a825";
            label = "Pending";
        }

        return (
          <Tooltip title="Set Status" arrow>
            <Chip
              label={label}
              variant="outlined"
              size="small"
              onClick={() => handleOpenDialogSt(params.row)}
              sx={{
                fontWeight: 400,
                backgroundColor: bgColor,
                color: "#fff",
                borderColor: bgColor,
                py: 1,
                px: 1,
              }}
            />
          </Tooltip>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 300,
      flex: 1,
      headerClassName: classes.tablheader200,
      headerAlign: "right",
      renderCell: (params: GridRenderCellParams) => (
        <Grid
          container
          spacing={1}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {params.row.status !== "Completed" && (
            <>
              <Grid item>
                <Tooltip title="Edit" arrow>
                  <IconButton
                    // variant="contained"
                    className={classes.editButtonListGridTable}
                    onClick={() => handleOpenDialog(params.row)}
                  >
                    <EditSharpIcon className={classes.editListIcon} />
                  </IconButton>
                </Tooltip>
              </Grid>
              {/* <Grid item>
                <Tooltip title="Reschedule" arrow>
                  <IconButton
                    // variant="contained"
                    className={classes.editButtonListGridTable}
                    onClick={() => handleOpenDialogRe(params.row)}
                  >
                    <RestoreIcon className={classes.editListIcon} />
                  </IconButton>
                </Tooltip>
              </Grid> */}
            </>
          )}
          <Grid item>
            <Link
              to={`/workshop/history/${params.row.id}`}
              className={classes.iconLinkPropNormal}
            >
              <Tooltip title="History" arrow>
                <IconButton
                  className={classes.viewButtonListGridTable}
                  onClick={() => navigate(`/workshop/history/${params.row.id}`)}
                >
                  <ListAltIcon className={classes.viewListIcon} />
                </IconButton>
              </Tooltip>
            </Link>
          </Grid>
          <Grid item>
            <Tooltip title="Delete" arrow>
              <IconButton
                // variant="contained"
                className={classes.deleteButtonListGridTable}
                onClick={() => handleOpenDeletePopup(params.row)}
              >
                <DeleteOutlineSharpIcon className={classes.deleteListIcon} />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      ),
    },
  ];

  const formattedRows = coursings.map((row) => ({
    id: row.id,
    name: row.name,
    workshopDateOnly: row.workshop_date,
    createDateOnly: row.created_at,
    finalStatus: row.status,
    email: row.email,
    phone_number: row.phone_number,
    workshop_date: row.workshop_date,
    status: row.status,
    note: row.note,
    no_of_participants: row.no_of_participants,
    message: row.message,
  }));

  const isAllSelected = selectedColumns.length === allColumns.length;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPaginationModel((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = parseInt(event.target.value, 10);
    setPaginationModel({ page: 0, pageSize: value });
  };

  return (
    <div>
      <Card className={classes.card}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid
              container
              justifyContent={"space-between"}
              spacing={5}
              sx={{ padding: 2, borderBottom: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  <Grid item>
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleToggle}
                    >
                      {isPaperVisible ? "Close Filter" : "Open Filter"}
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      // variant="contained"
                      startIcon={<SendIcon />}
                      className={classes.addNewButton}
                      onClick={handleNavigate}
                      disabled={selectedRowIds.length === 0}
                    >
                      E-mail
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      // variant="contained"
                      startIcon={<TableViewIcon />}
                      className={classes.addNewButton}
                      onClick={handleOpen}
                      disabled={selectedRowIds.length === 0}
                    >
                      Export to Excel
                    </Button>
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/workshop/feedback/list`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<ThumbUpOffAltIcon />}
                        className={classes.addNewButton}
                        onClick={handleFeedbackHistory}
                      >
                        FeedBack History
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/workshop/newsletter/e-mail/history`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<MarkEmailReadIcon />}
                        className={classes.addNewButton}
                        onClick={handleEmailHistory}
                      >
                        E-mail History
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      to={`/workshop/create`}
                      className={classes.iconLinkPropNormal}
                    >
                      <Button
                        startIcon={<BiSolidMessageSquareAdd />}
                        className={classes.addNewButton}
                        onClick={handleAddProductClick}
                      >
                        Add New
                      </Button>
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {isPaperVisible && (
              <>
                <Grid container spacing={3} my={5} p={4}>
                  <Grid item lg={2.4} md={6} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          From Date
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            onChange={handleStartDateChange}
                            value={startDate}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                            className={classes.searchTextField}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={2.4} md={6} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          To Date
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            onChange={handleEndDateChange}
                            value={endDate}
                            slotProps={{
                              textField: {
                                size: "small",
                                sx: { width: "100%" },
                                InputProps: {
                                  sx: { fontSize: 14 },
                                },
                                InputLabelProps: {
                                  sx: { fontSize: 14 },
                                },
                              },
                            }}
                            className={classes.searchTextField}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={3.6} md={12} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Status
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Autocomplete
                          multiple
                          options={finalStatusOptions}
                          value={finalStatusOptions.filter((option) =>
                            selectedFinalStatuses.includes(option.value)
                          )}
                          getOptionLabel={(option) => option.label}
                          onChange={(event, newValue) => {
                            setSelectedFinalStatuses(
                              newValue.map((item) => item.value)
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              InputLabelProps={{ shrink: true }}
                              placeholder="Select Status..."
                            />
                          )}
                          sx={{ flexGrow: 1, width: "100%" }}
                          size="small"
                          className={classes.searchTextField}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={3.6} md={12} sm={12} xs={12}>
                    <Grid container>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography
                          variant="subtitle1"
                          className={classes.body2}
                        >
                          Search Name / E-mail / Phone Number
                        </Typography>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <CiSearch
                                  className={classes.searchWidgetIcon}
                                />
                              </InputAdornment>
                            ),
                            classes: {
                              root: classes.formControlList,
                            },
                          }}
                          fullWidth
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          placeholder="Name, E-mail or Phone Number .."
                          sx={{ width: "100%" }}
                          size="small"
                          className={classes.searchTextField}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Box display="flex" justifyContent="flex-end">
                      <Button
                        variant="outlined"
                        startIcon={<RestartAltIcon />}
                        className={classes.addButton}
                        onClick={resetFields}
                      >
                        Reset
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </>
            )}
            <Grid>
              <Grid
                item
                sx={{ width: "100%", pb: 5, borderTop: 2, pt: 3 }}
                className={classes.titleGrid}
              >
                <div style={{ width: "100%" }}>
                  <TablePagination
                    component="div"
                    count={formattedRows.length}
                    page={paginationModel.page}
                    onPageChange={handleChangePage}
                    rowsPerPage={paginationModel.pageSize}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    rowsPerPageOptions={[
                      5,
                      10,
                      20,
                      50,
                      100,
                      formattedRows.length,
                    ]}
                  />
                  <DataGrid
                    rows={formattedRows.slice(
                      paginationModel.page * paginationModel.pageSize,
                      (paginationModel.page + 1) * paginationModel.pageSize
                    )}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    className={classes.dataGridTable}
                    onRowSelectionModelChange={handleRowSelection}
                    hideFooter
                  />
                  {/* <DataGrid
                    rows={formattedRows}
                    columns={columns}
                    getRowId={(row) => row.id}
                    autoHeight
                    pagination
                    initialState={{
                      pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    style={{ height: "100%", width: "100%" }}
                    className={classes.dataGridTable}
                    rowHeight={60}
                    checkboxSelection
                    disableRowSelectionOnClick
                    onRowSelectionModelChange={handleRowSelection}
                    getRowClassName={(params) =>
                      params.row.bgColor ? `row-bg-${params.row.id}` : ""
                    }
                  /> */}
                </div>
              </Grid>
            </Grid>
          </Grid>

          {selectedCoursing && (
            <NewPopUpCustomer
              openModel={openDialog}
              handleCloseDialog={handleCloseDialog}
              data={selectedCoursing}
            />
          )}
          {selectedCoursingSt && (
            <NewPopUpCustomerSt
              openModel={openDialogSt}
              handleCloseDialog={handleCloseDialogSt}
              data={selectedCoursingSt}
            />
          )}
          {selectedCoursingRe && (
            <NewPopUpCustomerRe
              openModel={openDialogRe}
              handleCloseDialog={handleCloseDialogRe}
              data={selectedCoursingRe}
            />
          )}

          {coursingToDelete && (
            <DeletePopup
              open={openDeleteCategory}
              handleCloseDelete={handleCloseDeletePopup}
              onConfirm={async () => {
                await handleDelete(coursingToDelete.id.toString());
              }}
              title="Delete Participant"
              content={`Are you sure you want to delete "${coursingToDelete.name}"?`}
            />
          )}

          <Dialog
            open={open}
            onClose={handleClose}
            aria-describedby="alert-dialog-description"
            classes={{ paper: "inherit" }}
            fullScreen={isMobile}
            fullWidth={isMobile}
            maxWidth="lg"
          >
            <Grid className={classes.Dialog}>
              <Grid container spacing={3}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={5}
                          sx={{ borderBottom: 2, padding: 2 }}
                          className={classes.titleGrid}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            pt={2}
                            alignContent={"center"}
                          >
                            <Typography className={classes.cardTitle}>
                              Select Columns to Export
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container spacing={3} p={"24px"}>
                          <Grid container spacing={3} p={"24px"}>
                            <>
                              <Grid item lg={12} md={12} sm={12} xs={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={isAllSelected}
                                      indeterminate={
                                        selectedColumns.length > 0 &&
                                        !isAllSelected
                                      }
                                      onChange={handleSelectAllChange}
                                    />
                                  }
                                  label="Select All"
                                />
                              </Grid>

                              {allColumns.map((column) => (
                                <Grid
                                  item
                                  lg={3}
                                  md={3}
                                  sm={12}
                                  xs={12}
                                  key={column}
                                >
                                  <FormControlLabel
                                    key={column}
                                    control={
                                      <Checkbox
                                        checked={selectedColumns.includes(
                                          column
                                        )}
                                        onChange={() =>
                                          handleCheckboxChange(column)
                                        }
                                      />
                                    }
                                    label={column}
                                  />
                                </Grid>
                              ))}
                            </>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Card className={classes.card}>
                        <Grid container spacing={3} p={"24px"}>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                            <Button
                              variant="outlined"
                              startIcon={<CloseIcon />}
                              className={classes.addButton}
                              onClick={handleClose}
                            >
                              Cancel
                            </Button>
                            <Box m={0.5}></Box>

                            <Button
                              variant="contained"
                              startIcon={<TableViewIcon />}
                              className={classes.addButton}
                              onClick={handleExport}
                              disabled={selectedColumns.length === 0 ||  selectedRowIds.length === 0}
                              // disabled={
                              //   !selectedRowIds || selectedRowIds.length === 0
                              // }
                            >
                              Export
                            </Button>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Dialog>
        </Grid>
      </Card>
    </div>
  );
};

export default Index;
